/* ============================================================================
 *  siteConfig.js — HygieniaTreeni
 *  Niche : Hygieniapassi (hygieniapassitesti) — Ruokavirasto (Suomi)
 *  Virallinen testi: 40 oikein/väärin-väittämää, hyväksytty 34/40, aika 45 min.
 *  Sääntely: Ruokaviraston määräys hygieniaosaamisesta 20/2025.
 *  NOTA (ES): Textos en finés. Sustituye checkoutUrl antes de lanzar.
 * ============================================================================ */

export const siteConfig = {
  saasKey: "hygieniapassi-fi",
  brand: {
    name: "HygieniaTreeni",
    namePrefix: "Hygienia",
    nameSuffix: "Treeni",
    subBrand: "by MIVX",
    tagline:
      "Harjoittele hygieniapassitestiin oikean testin kaltaisilla oikein/väärin-väittämillä.",
    flagEmoji: "🇫🇮",
    madeInLabel: "Ruokaviraston osaamisalueet",
    locale: "fi-FI",
    timezone: "Europe/Helsinki",
    socialLinks: [],
  },

  niche: {
    professionLabel: "Elintarvikealan työntekijä",
    aspirantLabel: "Hygieniapassin suorittaja",
    country: "Suomi",
    authority: "Ruokavirasto",
    phonePlaceholder: "+358 40 123 4567",
    flagshipLaw: "Ruokaviraston määräys hygieniaosaamisesta 20/2025",
  },

  officialReference:
    "Ruokaviraston määräyksen 20/2025 mukaiset osaamisalueet · 40 väittämää, läpäisyraja 34/40",

  sealLabels: {
    verified: "Tarkistettu",
    official: "Viralliset osaamisalueet",
    source: "Lähde: Ruokavirasto",
  },

  contact: {
    supportEmail: "go@mivx.com",
    salesEmail: "go@mivx.com",
  },

  payment: {
    checkoutUrl: "https://buy.stripe.com/dRm28q3Jqd2V6ZggNR0co1n", // TODO
    portalUrl: "",
    cancelSubscriptionEndpoint:
      "https://fgsacxsmkccogatuhofn.supabase.co/functions/v1/cancelar-suscripcion",
    providerName: "Stripe",
  },

  api: {
    geminiModel: "gemini-2.5-flash",
    aiErrorFallback:
      "Yhteys AI-opettajaan epäonnistui. Yritä hetken kuluttua uudelleen.",
  },

  seo: {
    title: "Hygieniapassi 2026 — Harjoittele testiin | HygieniaTreeni",
    description:
      "Harjoittele hygieniapassitestiin oikein/väärin-väittämillä. Testi on 40 väittämää ja läpäisyyn tarvitaan 34 oikein. Perustelut jokaiseen vastaukseen. Kokeile ilmaiseksi.",
    hiddenH1: "Hygieniapassitesti 2026: harjoituskysymykset ja simulaatiot",
    hiddenP:
      "Harjoittelualusta hygieniapassitestiin: mikrobiologia, ruokamyrkytykset, lämpötilahallinta, henkilökohtainen hygienia, puhtaanapito, omavalvonta ja lainsäädäntö.",
    keywords:
      "hygieniapassi, hygieniapassitesti, hygieniapassi harjoittelu, hygieniaosaamistesti, hygieniapassi kysymykset, hygieniapassi koe, ruokavirasto hygieniapassi",
    author: "HygieniaTreeni",
    domain: "suomenhygieniapassi.com",
    canonicalUrl: "https://suomenhygieniapassi.com/",
    ogImage: "/og-image-hygienia.png",
    ogTitle: "HygieniaTreeni — Harjoituskokeet hygieniapassitestiin",
    ogDescription:
      "Läpäise hygieniapassitesti ensimmäisellä yrittämällä. Yli 500 oikein/väärin-väittämää perusteluineen. Aloita ilmaiseksi.",
    schemaCourseName: "Hygieniapassitestin valmennus",
    schemaCourseDescription:
      "Harjoitussimulaattori ja väittämäpankki hygieniapassitestiin Ruokaviraston osaamisalueiden mukaisesti.",
  },

  // Paleta: verde fresco / lima (higiene y alimentación)
  colors: {
    primary: "#16a34a", // green-600
    primaryDark: "#15803d", // green-700
    accent: "#84cc16", // lime-500
    primaryTw: "green-600",
    primaryTwHover: "green-700",
    primaryTwLight: "green-50",
    primaryTwBorder: "green-200",
    primaryTwText: "green-800",
    secondaryTw: "lime-500",
    secondaryTwLight: "lime-50",
    accentTw: "lime-400",
    gradientFrom: "from-green-600",
    gradientTo: "to-lime-500",
  },

  stats: [
    { value: "+500", label: "Väittämää perusteluineen" },
    { value: "34/40", label: "Läpäisyraja virallisessa testissä" },
    { value: "7", label: "Ruokaviraston osaamisaluetta" },
    { value: "Rajattomasti", label: "Harjoitustestejä 45 min aikarajalla" },
  ],

  hero: {
    badge: "Sama muoto kuin virallisessa testissä: oikein / väärin",
    titleLine1: "Läpäise",
    titleLine2: "hygieniapassitesti ensimmäisellä kerralla",
    subtitle:
      "Virallisessa testissä on 40 oikein/väärin-väittämää ja läpäisyyn tarvitaan 34 oikein — eli vain kuusi virhettä sallitaan. Harjoittele samanmuotoisilla väittämillä, opi perustelu jokaiseen vastaukseen ja mene testiin varmana.",
    primaryCta: "Aloita ilmaiseksi",
    secondaryCta: "Kokeile harjoitustestiä",
    secondaryCtaBadge: "Ilmainen",
  },

  features: {
    sectionEyebrow: "Ominaisuudet",
    sectionTitle: "Kaikki hygieniaosaaminen yhdessä paikassa",
    sectionSubtitle:
      "Sisältö kattaa Ruokaviraston määräyksen 20/2025 mukaiset osaamisalueet: mikrobiologiasta ja ruokamyrkytyksistä lämpötilahallintaan, puhtaanapitoon ja omavalvontaan.",
    items: [
      {
        title: "Oikea testimuoto",
        description:
          "Harjoittele täsmälleen samassa muodossa kuin virallisessa testissä: sanallisia väittämiä, joihin vastataan oikein tai väärin.",
        color: "from-green-600 to-lime-500",
        iconKey: "clipboard",
        iconPath:
          "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
      },
      {
        title: "Perustelu joka väittämään",
        description:
          "Emme kerro vain oikeaa vastausta, vaan selitämme miksi — esimerkiksi miksi kuuma ruoka on säilytettävä vähintään +60 °C:ssa.",
        color: "from-lime-500 to-green-600",
        iconKey: "bulb",
        iconPath:
          "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
      },
      {
        title: "Aihekohtaiset moduulit",
        description:
          "Harjoittele erikseen mikrobiologiaa, ruokamyrkytyksiä, lämpötiloja, henkilökohtaista hygieniaa, puhtaanapitoa, omavalvontaa tai lainsäädäntöä.",
        color: "from-green-500 to-emerald-500",
        iconKey: "target",
        iconPath:
          "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
      },
      {
        title: "Ajantasainen sisältö",
        description:
          "Väittämät perustuvat voimassa olevaan elintarvikelainsäädäntöön ja Ruokaviraston määräykseen hygieniaosaamisesta (20/2025).",
        color: "from-emerald-500 to-green-600",
        iconKey: "book",
        iconPath:
          "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
      },
      {
        title: "Edistymisen seuranta",
        description:
          "Näet heti, hallitsetko lämpötilat mutta kompastut mikrobiologiaan. Kohdista harjoittelu heikoimpaan alueeseen.",
        color: "from-green-600 to-lime-400",
        iconKey: "chart",
        iconPath:
          "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
      },
      {
        title: "AI-opettaja",
        description:
          "Etkö muista, mikä on vaarallinen lämpötila-alue tai miten ruoka jäähdytetään oikein? Kysy AI-opettajalta milloin tahansa.",
        color: "from-lime-500 to-green-500",
        iconKey: "spark",
        iconPath: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      },
    ],
  },

  demo: {
    sectionEyebrow: "Testaa tasosi heti",
    sectionTitlePart1: "Harjoitustesti",
    sectionTitlePart2: "hygieniapassiin",
    sectionSubtitle:
      "Kokeile testin tyylisiä väittämiä ilman rekisteröitymistä tai maksukorttia.",
    bullets: [
      { label: "Oikein / väärin", icon: "✅", iconKey: "document-check" },
      { label: "45 min aikaraja", icon: "⏱️", iconKey: "clock" },
      { label: "Välitön arviointi", icon: "📊", iconKey: "chart" },
      { label: "Perustelut", icon: "💡", iconKey: "bulb" },
    ],
    ctaLabel: "Aloita testi",
    ctaBadge: "ILMAINEN!",
    answerCorrectLabel: "Oikein!",
    answerIncorrectLabel: "Väärä vastaus",
    questions: [
      {
        q: "Kuumana tarjottavan ruoan lämpötilan on oltava vähintään +60 °C.",
        o: ["Oikein", "Väärin"],
        c: 0,
        exp: "Kuumana tarjoiltavan tai myytävän ruoan lämpötilan on oltava vähintään +60 °C. Tätä alemmissa lämpötiloissa mikrobit pääsevät lisääntymään nopeasti.",
      },
      {
        q: "Helposti pilaantuvat elintarvikkeet säilytetään enintään +6 °C:ssa.",
        o: ["Oikein", "Väärin"],
        c: 0,
        exp: "Helposti pilaantuvat elintarvikkeet on säilytettävä kylmässä, pääsääntöisesti enintään +6 °C:ssa. Osalla tuotteista, kuten jauhelihalla ja kalalla, on tätäkin tiukemmat vaatimukset.",
      },
      {
        q: "Sulatettu pakaste voidaan pakastaa uudelleen ilman riskiä.",
        o: ["Oikein", "Väärin"],
        c: 1,
        exp: "Väärin. Sulaneen elintarvikkeen uudelleenpakastaminen ei ole suositeltavaa: sulaessa rakenne rikkoutuu ja mikrobit ovat päässeet lisääntymään. Sulatettu tuote on käytettävä pian.",
      },
      {
        q: "Käsien pesu riittää korvaamaan suojakäsineiden käytön aina.",
        o: ["Oikein", "Väärin"],
        c: 1,
        exp: "Väärin. Käsienpesu on hygienian perusta, mutta se ei korvaa suojakäsineitä tilanteissa, joissa niitä tarvitaan. Toisaalta käsineetkään eivät korvaa käsienpesua — kädet pestään myös ennen käsineiden pukemista.",
      },
    ],
  },

  pricing: {
    eyebrow: "Yksi hinta",
    eyebrowTitle1: "Kertamaksu",
    eyebrowTitle2: "Rajaton harjoittelu",
    eyebrowSubtitle:
      "Täysi pääsy kaikkiin väittämiin ja harjoitustesteihin. Maksat vain niin kauan kuin valmistaudut.",
    stickyNote: "Ei sitoutumista",
    anchorPrice: null,
    reassurance: [
      { label: "Turvallinen maksu Stripella", iconKey: "stripe" },
      { label: "Peruuta milloin tahansa", iconKey: "no-lock" },
      { label: "Välitön pääsy", iconKey: "check" },
    ],
    plan: {
      name: "Hygienia Pass",
      price: "14,99 €",
      currency: "",
      period: "/kk",
      priceSubtext: "Halvempi kuin uusintatestin maksu",
      description:
        "Täysi pääsy kaikkiin osaamisalueisiin, harjoitustesteihin ja AI-opettajaan.",
      features: [
        "Yli 500 väittämää perusteluineen",
        "Harjoitustestit 40 väittämällä ja 45 min aikarajalla",
        "Kaikki Ruokaviraston osaamisalueet",
        "AI-opettaja elintarvikehygieniasta",
        "Edistymisen seuranta aiheittain",
        "Toimii puhelimella, tabletilla ja koneella",
      ],
      ctaLabel: "Aloita harjoittelu",
      benefitsList: [
        "Sama testimuoto kuin virallisessa testissä",
        "Rajaton harjoittelu",
        "+500 väittämää perusteluineen",
        "AI-opettaja käytössä 24/7",
        "Harjoittele missä tahansa",
        "Kaikki osaamisalueet katettu",
        "Edistymistilastot",
        "Nopea tuki",
      ],
    },
  },

  faq: {
    eyebrow: "Usein kysytyt kysymykset",
    title: "Vastauksia ennen kuin aloitat",
    subtitle: "Näitä hygieniapassin suorittajat kysyvät useimmin.",
    items: [
      {
        question: "Kuka tarvitsee hygieniapassin?",
        answer:
          "Hygieniapassi tarvitaan, jos työskentelet elintarvikehuoneistossa ja käsittelet työssäsi pakkaamattomia, helposti pilaantuvia elintarvikkeita. Sitä edellytetään esimerkiksi ravintoloissa, kahviloissa, suurkeittiöissä ja elintarviketeollisuudessa.",
      },
      {
        question: "Millainen virallinen hygieniapassitesti on?",
        answer:
          "Testi koostuu 40 oikein/väärin-väittämästä. Läpäisyyn tarvitaan vähintään 34 oikein, eli enintään kuusi virhettä. Vastausaikaa on 45 minuuttia, ja testi tehdään Ruokaviraston hyväksymän hygieniapassitestaajan valvonnassa.",
      },
      {
        question: "Onko hygieniapassi voimassa määräajan?",
        answer:
          "Ei. Elintarvikelain mukaan hygieniapassi on voimassa toistaiseksi — sitä ei tarvitse uusia määräajoin. Osaamista kannattaa silti pitää yllä työssä.",
      },
      {
        question: "Saanko hygieniapassin tältä sivustolta?",
        answer:
          "Et. HygieniaTreeni on harjoitusalusta. Virallisen testin järjestää ja hygieniapassin myöntää Ruokaviraston hyväksymä hygieniapassitestaaja. Suomessa testaajia on yli 2 000 ympäri maata.",
      },
      {
        question: "Ovatko väittämänne samoja kuin virallisessa testissä?",
        answer:
          "Eivät. Ruokaviraston testiväittämät ovat sen omaisuutta eikä niitä saa kopioida. Meidän väittämämme ovat itse laadittuja mutta samassa muodossa ja samoista osaamisalueista, jotta harjoittelu vastaa oikeaa testiä.",
      },
    ],
  },

  platformIncludes: {
    eyebrow: "Alusta",
    title: "Kaikki mitä läpäisyyn tarvitaan",
    subtitle:
      "Selkeät väittämät, perustelut ja aikarajalliset harjoitustestit.",
    items: [
      {
        icon: "📚",
        iconKey: "book",
        title: "+500 väittämää",
        description:
          "Jokaiseen väittämään perustelu: miksi vastaus on oikein tai väärin.",
      },
      {
        icon: "⏱️",
        iconKey: "clock",
        title: "Harjoitustestit",
        description:
          "40 väittämää, 45 minuuttia, läpäisyraja 34/40 — täsmälleen kuten oikeassa testissä.",
      },
      {
        icon: "🌡️",
        iconKey: "document-check",
        title: "Käytännön tilanteet",
        description:
          "Lämpötilat, jäähdytys, ristikontaminaatio ja siivous työn arjen tilanteissa.",
      },
      {
        icon: "📊",
        iconKey: "chart",
        title: "Edistymistutka",
        description:
          "Näet heti, mikä osaamisalue kaipaa vielä kertausta ennen testipäivää.",
      },
    ],
  },

  trustStrip: [
    { icon: "✅", iconKey: "flag", label: "Ruokaviraston osaamisalueet" },
    { icon: "🔒", iconKey: "lock", label: "Turvallinen maksu Stripella" },
    {
      icon: "🚫",
      iconKey: "no-lock",
      label: "Ei sitoutumista · Peruutus yhdellä klikkauksella",
    },
    {
      icon: "🍽️",
      iconKey: "document-check",
      label: "40 väittämää · 34/40 läpi",
    },
  ],

  howItWorks: {
    eyebrow: "Näin se toimii",
    title: "Hygieniapassi kolmessa vaiheessa",
    subtitle: "Harjoittele fiksusti — älä arvaile testipäivänä.",
    steps: [
      {
        icon: "✨",
        iconKey: "spark",
        title: "Testaa lähtötasosi",
        description:
          "Tee ilmainen harjoitustesti tällä sivulla ja katso, kuinka monta väittämää saat oikein.",
      },
      {
        icon: "📝",
        iconKey: "clipboard",
        title: "Luo tili",
        description:
          "Rekisteröidy ilmaiseksi, tutustu osaamisalueisiin ja tallenna harjoitteluhistoriasi.",
      },
      {
        icon: "🏆",
        iconKey: "trophy",
        title: "Harjoittele ja mene testiin",
        description:
          "Avaa koko väittämäpankki ja harjoitustestit, ja ilmoittaudu hygieniapassitestaajalle varmana.",
      },
    ],
  },

  comparison: {
    eyebrow: "Miksi HygieniaTreeni",
    title: "Harjoitellen vai arvaillen?",
    subtitle:
      "Testissä sallitaan vain kuusi virhettä. Ero läpäisyn ja uusintamaksun välillä on harjoittelussa.",
    withLabel: "HygieniaTreenillä",
    withoutLabel: "Omin päin",
    rows: [
      {
        label: "Sama muoto kuin virallisessa testissä",
        withUs: true,
        without: false,
      },
      { label: "Aikarajalliset harjoitustestit", withUs: true, without: false },
      {
        label: "Perustelu jokaiseen väittämään",
        withUs: true,
        without: "Hajanaisia nettivinkkejä",
      },
      { label: "Heikkouksien mittaaminen", withUs: true, without: false },
      { label: "AI-opettaja käytössä 24/7", withUs: true, without: false },
      {
        label: "Vaadittu sijoitus",
        withUs: "14,99 €/kk, ei sitoutumista",
        without: "Uusintatesti maksaa joka kerta",
      },
    ],
  },

  ai: {
    chatTitle: "HygieniaTreenin AI-opettaja",
    welcomeMessage:
      "Hei! Olen elintarvikehygienian AI-opettajasi. Kysy minulta vaikka lämpötilarajoista, ruokamyrkytysbakteereista, jäähdytyksestä, ristikontaminaatiosta tai omavalvonnasta.",
    systemInstructionDefault:
      "Olet elintarvikehygienian asiantuntija ja valmennat käyttäjiä Suomen hygieniapassitestiin. Tunnet Ruokaviraston määräyksen hygieniaosaamisesta (20/2025) osaamisalueet: mikrobiologian perusteet ja kontaminaatio, ruokamyrkytykset, hygieeniset työtavat ja lämpötilahallinta, henkilökohtainen hygienia, puhtaanapito, omavalvonta sekä elintarvikelainsäädäntö ja viranomaisvalvonta. Vastaa suomeksi (fi-FI) lyhyesti, selkeästi ja täsmällisesti. Käytä oikeita lämpötilarajoja (mm. kuuma ruoka vähintään +60 °C, helposti pilaantuvat enintään +6 °C, pakaste -18 °C, jäähdytys alle +6 °C:een enintään neljässä tunnissa). Älä keksi säädöksiä tai lukuja.",
    systemInstructionTutor:
      "Olet kärsivällinen hygieniapassiopettaja. Selität asiat yksinkertaisesti myös sellaiselle, joka opiskelee suomeksi vieraana kielenä. Käytä konkreettisia esimerkkejä keittiön arjesta. Vastaa suomeksi (fi-FI).",
    casePromptTemplate: (topicTitle) =>
      `Laadi lyhyt käytännön tilanne (enintään 80 sanaa) aiheesta "${topicTitle}", jossa elintarvikealan työntekijä on keittiössä tai myymälässä. Kysy, toimiiko työntekijä oikein vai väärin ja miksi.`,
    caseSystemInstruction:
      "Olet elintarvikehygienian kouluttaja ja laadit hygieniapassitestin kaltaisia tilanteita.",
    inputPlaceholder: "Kirjoita kysymyksesi elintarvikehygieniasta...",
  },

  exam: {
    simulatorQuestions: 40, // Kuten virallisessa testissä
    simulatorDurationMinutes: 45, // Virallinen vastausaika
    topicWeights: [
      { id: "t1", weight: 0.15 }, // Mikrobiologia ja kontaminaatio
      { id: "t2", weight: 0.15 }, // Ruokamyrkytykset
      { id: "t3", weight: 0.2 }, // Lämpötilahallinta ja säilytys
      { id: "t4", weight: 0.15 }, // Hygieeniset työtavat
      { id: "t5", weight: 0.15 }, // Henkilökohtainen hygienia
      { id: "t6", weight: 0.1 }, // Puhtaanapito
      { id: "t7", weight: 0.1 }, // Omavalvonta ja lainsäädäntö
    ],
    passingScore: 85, // 34/40 = 85 %
    simulatorTitle: "Hygieniapassin harjoitustesti",
    exitModal: {
      title: "Keskeytetäänkö testi?",
      lead: "Vastauksesi menetetään!",
      warning:
        "Merkitsemiäsi vastauksia ei tallenneta, ja joudut aloittamaan harjoitustestin alusta.",
      confirmLabel: "Kyllä, keskeytä",
      cancelLabel: "Jatka testiä",
      footnote: "Edistymisesi nollautuu, jos poistut nyt",
      closeLabel: "Sulje",
    },
  },

  uiCopy: {
    loading: "Ladataan...",
    ready: "Valmiina",
    navHome: "Etusivu",
    navStudy: "Osaamisalueet",
    navStudyShort: "Aiheet",
    navQuizzes: "Harjoitusmoduulit",
    navQuizzesShort: "Moduulit",
    navSimulator: "Harjoitustesti",
    navBilling: "Tilaukseni",
    sidebarPrincipal: "Yleiskatsaus",
    sidebarSimulation: "Harjoitustesti",
    bannerCta: "🎓 Avaa koko väittämäpankki ja läpäise hygieniapassitesti",
    bannerCtaButton: "Premium",
    legalLastUpdate: "Viimeksi päivitetty: 15.1.2026",
    cta: {
      finalSectionTitle: "Valmis suorittamaan hygieniapassin?",
      finalSectionSubtitle:
        "Harjoittele yli 500 väittämällä kaikilta osaamisalueilta. Vain kuusi virhettä sallitaan — varmista läpäisy.",
      finalSectionPrimary: "Aloita harjoittelu",
      finalSectionSecondary: "Ota yhteyttä tukeen",
      finalSectionFooter: "✨ Välitön pääsy · Peruuta milloin tahansa",
      contactModalTitle: "Asiakastuki",
      contactModalSubtitle: "Onko jokin epäselvää? Kirjoita meille suoraan:",
      contactModalClose: "Sulje ikkuna",
      contactModalCloseAriaLabel: "Sulje",
    },
    masterDomainLabel: "Elintarvikehygienian hallinta",
    statsCards: {
      generalProgress: "Kokonaisedistyminen",
      sectionsRead: "Suoritetut moduulit",
      examsTaken: "Harjoitustestit",
      bestScore: "Paras tulos",
    },
    auth: {
      welcomeTitle: "Tervetuloa takaisin",
      welcomeSubtitle: "Kirjaudu sisään jatkaaksesi harjoittelua",
      registerTitle: "Luo tili",
      registerSubtitle: "Ota ensimmäinen askel kohti hygieniapassia",
    },
    landing: {
      productNavLabel: "Alusta",
      productLinks: [
        { href: "#features", label: "Ominaisuudet" },
        { href: "#pricing", label: "Hinnat" },
        { href: "#demo", label: "Ilmainen testi" },
        { href: "#testimonials", label: "Kokemuksia" },
      ],
    },
  },
  // ==========================================================================
  //  LEGALCOPY — Todo el texto legal del sitio (Käyttöehdot / Tietosuoja / Huomautus)
  //  Marcadores disponibles: {{company}} {{operator}} {{operatorLocation}}
  //                          {{domain}} {{email}} {{price}} {{provider}} {{law}}
  //  Para clonar a otro idioma: traducir SOLO este bloque.
  // ==========================================================================
  legalCopy: {
    pageEyebrow: "Oikeudelliset tiedot",
    pageTitleLine1: "Oikeudelliset",
    pageTitleLine2: "tiedot",
    tablistLabel: "Oikeudelliset asiakirjat",
    backHome: "Takaisin etusivulle",
    tabs: {
      notice: "Oikeudellinen huomautus",
      terms: "Käyttöehdot",
      privacy: "Tietosuojaseloste",
    },

    notice: {
      s1Title: "Palvelun ylläpitäjä",
      s1TextBefore: "Palvelua {{company}} (osoitteessa",
      s1TextAfter:
        ") ylläpitää ja siitä vastaa {{operator}}, ranskalaisen oikeuden mukainen yksinkertaistettu osakeyhtiö (SAS), kotipaikka {{operatorLocation}}.",
      s2Title: "Julkaisusta vastaava",
      s2Text: "Julkaisusta vastaa {{operator}} -yhtiön laillinen edustaja.",
      s3Title: "Yhteystiedot",
      s3Text:
        "Oikeudellisissa, teknisissä ja kaupallisissa kysymyksissä voit ottaa yhteyttä sähköpostitse:",
      s4Title: "Palvelinisännöinti ja tekniset toimittajat",
      s4Text:
        "Palvelu toimii ulkopuolisten palveluntarjoajien infrastruktuurissa (mm. sovellusalusta, tietokanta ja maksunvälitys). Maksut käsittelee {{provider}}; {{company}} ei tallenna maksukorttitietoja.",
      s5Title: "Verkkovälitteinen riidanratkaisu (EU)",
      s5Text:
        "Asetuksen (EU) N:o 524/2013 mukaisesti Euroopan komissio tarjoaa kuluttajille verkkovälitteisen riidanratkaisualustan:",
      s6Title: "Tavaramerkki",
      s6Text:
        "{{company}} on {{operator}} -yhtiön ylläpitämä kaupallinen tuotenimi.",
    },

    terms: {
      sections: [
        {
          title: "Ehtojen hyväksyminen",
          paragraphs: [
            {
              text: "Käyttämällä palvelua {{company}} käyttäjä hyväksyy nämä käyttöehdot kokonaisuudessaan. Jos et hyväksy ehtoja, älä käytä palvelua.",
            },
          ],
        },
        {
          title: "Palvelun kuvaus",
          paragraphs: [
            {
              text: "{{company}} on itsenäinen koulutuspalvelu, joka tarjoaa harjoituskysymyksiä, harjoituskokeita ja opiskelumateriaalia hygieniapassitestiin valmistautumista varten. Palvelu ei ole viranomainen eikä sillä ole yhteyttä Ruokavirastoon tai hygieniapassitestaajiin.",
            },
          ],
        },
        {
          title: "Palvelun sallittu käyttö",
          paragraphs: [
            {
              text: "Käyttäjä sitoutuu käyttämään palvelua ainoastaan henkilökohtaisiin opiskelutarkoituksiin. Sisällön kopiointi, jakelu, jälleenmyynti tai julkaiseminen ilman lupaa on kiellettyä. Käyttöoikeus on henkilökohtainen eikä tunnuksia saa luovuttaa kolmannelle.",
            },
          ],
        },
        {
          title: "Tilin rekisteröinti",
          paragraphs: [
            {
              text: "Osa toiminnoista edellyttää tilin luomista. Käyttäjän on annettava oikeat ja ajantasaiset tiedot sekä huolehdittava tunnustensa säilyttämisestä. Käyttäjä vastaa kaikesta tunnuksillaan tapahtuvasta toiminnasta.",
            },
          ],
        },
        {
          title: "Hinnat ja laskutus",
          paragraphs: [
            {
              text: "Premium-tilauksen hinta on {{price}} (tai etusivulla kulloinkin ilmoitettu hinta). Tilaamalla käyttäjä hyväksyy automaattisen kuukausiveloituksen. {{company}} voi muuttaa hintoja ilmoittamalla muutoksesta etukäteen rekisteröityyn sähköpostiosoitteeseen.",
            },
            {
              text: "Maksut käsittelee {{provider}}. {{company}} ei tallenna maksukorttitietoja.",
            },
          ],
        },
        {
          title: "Peruutus- ja palautuskäytäntö",
          paragraphs: [
            {
              strong: "Peruutus:",
              text: "Käyttäjä voi peruuttaa tilauksensa milloin tahansa asetuksistaan. Peruutuksen jälkeen käyttöoikeus jatkuu jo maksetun laskutuskauden loppuun, eikä uusia veloituksia tehdä.",
            },
            {
              strong: "Ei palautuksia:",
              text: "Maksettuja maksuja ei palauteta osittain eikä kokonaan sen jälkeen, kun maksu on käsitelty, ellei pakottavasta kuluttajansuojalainsäädännöstä muuta johdu.",
            },
            {
              strong: "Peruuttamisoikeus (EU):",
              text: "Kuluttajalla on lähtökohtaisesti 14 päivän peruuttamisoikeus. Koska kyseessä on välittömästi toimitettava digitaalinen palvelu, käyttäjä pyytää palvelun välitöntä toimittamista ja hyväksyy tilausta tehdessään, että peruuttamisoikeus raukeaa käyttöoikeuden alkaessa.",
            },
          ],
        },
        {
          title: "Ei takuuta testin läpäisemisestä",
          paragraphs: [
            {
              text: "{{company}} on opiskelun tukiväline. Emme takaa hygieniapassitestin läpäisemistä. Tulos riippuu käyttäjän omasta valmistautumisesta ja suorituksesta.",
            },
          ],
        },
        {
          title: "Oikeudellinen huomautus ja tietolähteet",
          paragraphs: [
            {
              text: "Sisältö perustuu julkisiin lähteisiin ja voimassa olevaan lainsäädäntöön, ja se on laadittu huolellisesti. Emme kuitenkaan takaa sisällön virheettömyyttä tai ajantasaisuutta emmekä vastaa sisältöön luottamisesta aiheutuvista seurauksista. Virallinen ja sitova tieto on aina tarkistettava Ruokavirastolta ja ajantasaisesta elintarvikelainsäädännöstä.",
            },
            {
              text: "Palvelun väittämät ovat itse laadittuja. Ne eivät ole Ruokaviraston virallisia testiväittämiä, jotka ovat Ruokaviraston omaisuutta. Palvelu ei ole Ruokaviraston hyväksymä eikä sen kanssa yhteydessä.",
            },
          ],
        },
        {
          title: "Vastuunrajoitus",
          paragraphs: [
            {
              text: "{{company}} ei vastaa välillisistä vahingoista, saamatta jääneestä voitosta eikä palvelun käyttökatkoksista. Vastuu rajoittuu enintään käyttäjän viimeisen kahdentoista kuukauden aikana maksamaan määrään, ellei pakottavasta lainsäädännöstä muuta johdu.",
            },
          ],
        },
        {
          title: "Tilin jäädyttäminen tai sulkeminen",
          paragraphs: [
            {
              text: "{{company}} voi jäädyttää tai sulkea tilin, jos näitä ehtoja rikotaan, esimerkiksi tunnusten jakamisen tai sisällön luvattoman levittämisen vuoksi.",
            },
          ],
        },
        {
          title: "Palvelun muutokset",
          paragraphs: [
            {
              text: "Palvelun sisältöä ja toimintoja voidaan kehittää ja muuttaa. Olennaisista muutoksista ilmoitetaan käyttäjille.",
            },
          ],
        },
        {
          title: "Sovellettava laki",
          paragraphs: [
            {
              text: "Näihin ehtoihin sovelletaan Suomen lakia siltä osin kuin kuluttajaa suojaava pakottava lainsäädäntö sitä edellyttää. Kuluttaja voi saattaa riidan kuluttajariitalautakunnan käsiteltäväksi tai nostaa kanteen kotipaikkansa käräjäoikeudessa.",
            },
          ],
        },
      ],
    },

    privacy: {
      sections: [
        {
          title: "Johdanto",
          paragraphs: [
            {
              text: "Tässä selosteessa kerrotaan, miten {{company}} käsittelee henkilötietoja EU:n yleisen tietosuoja-asetuksen (GDPR) mukaisesti.",
            },
          ],
        },
        {
          title: "Rekisterinpitäjä",
          paragraphs: [
            {
              text: "Rekisterinpitäjä on {{operator}}, kotipaikka {{operatorLocation}}. Tietosuoja-asioissa voit ottaa yhteyttä osoitteeseen:",
            },
          ],
          contactEmail: true,
        },
        {
          title: "Keräämämme tiedot",
          paragraphs: [
            {
              text: "Keräämme vain palvelun toiminnan kannalta tarpeelliset tiedot: nimi, sähköpostiosoite, mahdollinen puhelinnumero, opiskelun edistyminen, harjoituskokeiden tulokset sekä tilaustiedot.",
            },
          ],
        },
        {
          title: "Tietojen käyttö",
          paragraphs: [
            {
              text: "Käytämme tietoja käyttäjätilien hallintaan, opiskelun edistymisen näyttämiseen, palvelun kehittämiseen, asiakastukeen sekä tilausten ja maksujen hallinnointiin. Emme myy henkilötietoja kolmansille.",
            },
          ],
        },
        {
          title: "Käsittelyn oikeusperuste",
          paragraphs: [
            {
              text: "Käsittelyn perusteena on sopimuksen täytäntöönpano (käyttäjätili ja tilaus), lakisääteiset velvoitteet (kirjanpito) sekä oikeutettu etu (palvelun kehittäminen ja tietoturva).",
            },
          ],
        },
        {
          title: "Tietojen luovuttaminen",
          paragraphs: [
            {
              text: "Tietoja luovutetaan vain palvelun toiminnan edellyttämille käsittelijöille, kuten palvelinisännöinnin, tietokannan ja maksunvälityksen tarjoajille, jotka käsittelevät tietoja lukuumme ja ohjeidemme mukaisesti.",
            },
          ],
        },
        {
          title: "Tietoturva",
          paragraphs: [
            {
              text: "Käytämme teknisiä ja organisatorisia suojatoimia, kuten salattua tiedonsiirtoa ja pääsynhallintaa, suojataksemme tiedot luvattomalta pääsyltä, häviämiseltä ja muuttamiselta.",
            },
          ],
        },
        {
          title: "Rekisteröidyn oikeudet",
          paragraphs: [
            {
              text: "Sinulla on oikeus saada pääsy tietoihisi, oikaista ja poistaa ne, rajoittaa ja vastustaa käsittelyä sekä siirtää tiedot järjestelmästä toiseen. Voit myös peruuttaa antamasi suostumuksen. Sinulla on oikeus tehdä valitus tietosuojavaltuutetun toimistolle.",
            },
          ],
        },
        {
          title: "Tietojen säilytys",
          paragraphs: [
            {
              text: "Säilytämme henkilötietoja vain niin kauan kuin se on tarpeen palvelun tarjoamiseksi tai lakisääteisten velvoitteiden täyttämiseksi. Tämän jälkeen tiedot poistetaan tai anonymisoidaan.",
            },
          ],
        },
        {
          title: "Evästeiden käyttö",
          paragraphs: [
            {
              text: "Palvelu voi käyttää evästeitä ja vastaavia tekniikoita kirjautumisen ylläpitämiseen, asetusten muistamiseen ja käytön analysointiin. Voit hallita evästeitä selaimesi asetuksista.",
            },
          ],
        },
        {
          title: "Muutokset selosteeseen",
          paragraphs: [
            {
              text: "Selostetta voidaan päivittää. Olennaisista muutoksista ilmoitetaan palvelussa tai sähköpostitse.",
            },
          ],
        },
      ],
    },
  },

  legal: {
    companyName: "HygieniaTreeni by MIVX",
    companyShortName: "HygieniaTreeni",
    governingLaw: "Suomi",
    privacyContactEmail: "go@mivx.com",
    operatorName: "PAUL BREMOND SAS",
    operatorLocation: "Pariisi, Ranska",
  },
};

export default siteConfig;
